import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 30,
  },
  containerAlert: {
    marginTop: 20,
  },
  containerList: {
    marginTop: 0,
    marginBottom: 270,
  },
  spaceSummary: {
    // marginTop: 40,
    paddingHorizontal: 5,
  },
  containerSummary: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  summaryText: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'black',
  },
  quantityText: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'black',
  },
  containerSubtotal: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  subtotalText: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'black',
  },
  priceText: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'black',
  },
  containerTotal: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  totalText: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'black',
  },
  totalPrice: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'black',
  },
  containerButton: {
    marginTop: 24,
    marginBottom: 24,
    alignSelf: 'center',
    width: '100%',
    gap: 16,
  },
});